<template>
  <div
    class="download-button"
    @click="$_downloadClick(url, fileName)"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "DownloadButton",
  props: {
    url: {
      type: String,
      default: "",
    },
    fileName: {
      type: String,
      default: "",
    },
  },
  methods: {
    $_downloadClick(url, filename) {
      if (!url) return;
      this.$emit("download-click");
      fetch(url).then(function (t) {
        return t.blob().then((b) => {
          let attach = document.createElement("a");
          attach.href = URL.createObjectURL(b);
          attach.setAttribute("download", filename);
          attach.click();
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>